export function formatApiErrorMessage(errorLike, fallback = "Une erreur est survenue") {
  const seen = new WeakSet();

  const toText = (value) => {
    if (value == null) return "";
    if (typeof value === "string") return value.trim();
    if (typeof value === "number" || typeof value === "boolean") return String(value);

    if (Array.isArray(value)) {
      const parts = value.map(toText).filter(Boolean);
      return parts.join(" | ");
    }

    if (typeof value === "object") {
      if (seen.has(value)) return "";
      seen.add(value);

      if (value.detail != null) return toText(value.detail);
      if (typeof value.msg === "string" && value.msg.trim()) {
        const loc = Array.isArray(value.loc) ? value.loc.join(".") : "";
        return loc ? `${loc}: ${value.msg}` : value.msg;
      }
      if (typeof value.message === "string" && value.message.trim()) return value.message;
      if (typeof value.error === "string" && value.error.trim()) return value.error;

      try {
        const raw = JSON.stringify(value);
        return raw && raw !== "{}" ? raw : "";
      } catch {
        return "";
      }
    }

    return "";
  };

  const text = toText(errorLike);
  return text || fallback;
}

